export default (str: string): string => str.replace(/ /g, '');
